export const validateEmail = (email?: string | null): boolean => {
    if (!email || email.trim() === "") {
        return true; // Allow empty emails
    }
    //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

export const validateDomain = (domain?: string | null): boolean => {
    if (!domain || domain.trim() === "") {
        return true; // Allow empty domains
    }

    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
    return domainRegex.test(domain);
};


